export default __webpack_public_path__ + "static/media/chose.657af9b2.jpg";